import oneTrust from '../../common/consent/OneTrust';
import { getGoogleAnalyticsProperty } from '../../common/utils/analytics/getGoogleAnalyticsProperty';
import { historySingleton } from '../history';
import { comscoreTrackPageview } from './comscore/comscoreUtils';
import { fbTrackPageView } from './facebook/fbTrack';
import { gtag } from './google/gaTracking';
import initComscore from './vendorScripts/initComscore';
import initFbTrack from './vendorScripts/initFbTrack';
import initGoogleConversion from './vendorScripts/initGoogleConversion';
import loadAmpBingTracking from './vendorScripts/loadAmpBingTracking';
import { createGlobalGTagFunction } from './vendorScripts/loadGTag';
import loadYahooPixelTracking from './vendorScripts/loadYahooPixelTracking';

function loadDependencies(
  location,
  googleAnalyticsPropertyId,
  isOptedOutOfPerformance,
  isOptedOutOfTargeting,
  gdprApplies,
) {
  createGlobalGTagFunction(googleAnalyticsPropertyId);
  initFbTrack(gdprApplies, isOptedOutOfTargeting);
  initGoogleConversion();
  loadAmpBingTracking();
  loadYahooPixelTracking();
  initComscore(isOptedOutOfPerformance);
}

export async function initClientAnalytics() {
  const googleAnalyticsPropertyId = getGoogleAnalyticsProperty();

  const [isOptedOutOfPerformance, isOptedOutOfTargeting, gdprApplies] = await Promise.all([
    oneTrust.checkIsOptedOutOfPerformance(),
    oneTrust.checkIsOptedOutOfTargeting(),
    oneTrust.checkGdprApplicability(),
  ]);

  loadDependencies(
    historySingleton.location,
    googleAnalyticsPropertyId,
    isOptedOutOfPerformance,
    isOptedOutOfTargeting,
    gdprApplies,
  );
}

export async function sendPageView(location) {
  const path = location.pathname || '';
  const googleAnalyticsPropertyId = getGoogleAnalyticsProperty();
  const isOptedOutOfPerformance = await oneTrust.checkIsOptedOutOfPerformance();

  gtag('set', 'page', path);
  gtag('config', googleAnalyticsPropertyId);
  comscoreTrackPageview(isOptedOutOfPerformance);
  fbTrackPageView(path);
}
